<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise" style="overflow-y: auto; max-height: calc(90vh - 200px);">
  <form #dataServiceForm="ngForm">
    <div class="fluid-container form-grid">
      <div class="form-group mt-3">
        <label>Schema Set ID*</label>
        <input class="form-control" type="text" name="schemasetid" [(ngModel)]="rowData.SCHEMA_SET_ID" required>
        @if (dataServiceForm.form?.get('schemasetid')?.invalid && dataServiceForm.form?.get('schemasetid')?.touched) {
<span class="form-error-container">
          Schema set ID is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Element Name*</label>
        <input class="form-control" type="text" name="elementname" [(ngModel)]="rowData.ELEMENT_NAME" required>
        @if (dataServiceForm.form?.get('elementname')?.invalid && dataServiceForm.form?.get('elementname')?.touched) {
<span class="form-error-container">
          Element name is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Description</label>
        <input class="form-control" type="text" name="description" [(ngModel)]="rowData.DESCRIPTION">
      </div>
      <div class="form-group mt-3">
        <label>Line</label>
        <input class="form-control" type="text" name="line" [(ngModel)]="rowData.LINE_NO">
      </div>
      <div class="form-group mt-3">
        <label>Type Schema</label>
        <input class="form-control" type="text" name="typeschema" [(ngModel)]="rowData.TYPE_SCHEMA">
      </div>
      <div class="form-group mt-3">
        <label>Type Base*</label>
        <input class="form-control" type="text" name="typebase" [(ngModel)]="rowData.TYPE_BASE" required>
        @if (dataServiceForm.form?.get('typebase')?.invalid && dataServiceForm.form?.get('typebase')?.touched) {
<span class="form-error-container">
          Type base is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Type Oracle*</label>
        <input class="form-control" type="text" name="oracletype" [(ngModel)]="rowData.TYPE_ORACLE" required>
        @if (dataServiceForm.form?.get('oracletype')?.invalid && dataServiceForm.form?.get('oracletype')?.touched) {
<span class="form-error-container">
          Type Oracle is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Required Options</label>
        <input class="form-control" type="text" name="isrequired" [(ngModel)]="rowData.IS_REQUIRED">
      </div>
      <div class="form-group mt-3">
        <label>Choice Min Occurs</label>
        <input class="form-control" type="text" name="choiceminoccurs" [(ngModel)]="rowData.CHOICE_MIN_OCCURS">
      </div>
      <div class="form-group mt-3">
        <label>Choice Group ID</label>
        <input class="form-control" type="text" name="choicegroupid" [(ngModel)]="rowData.CHOICE_GROUP_ID">
      </div>
      <div class="form-group mt-3">
        <label>Choice Sequence</label>
        <input class="form-control" type="text" name="choiceseq" [(ngModel)]="rowData.CHOICE_SEQ">
      </div>
      <div class="form-group mt-3">
        <label>Choice Level</label>
        <input class="form-control" type="text" name="choicelevel" [(ngModel)]="rowData.CHOICE_LEVEL">
      </div>
      <div class="form-group mt-3">
        <label>Length</label>
        <input class="form-control" type="text" name="len" [(ngModel)]="rowData.LENGTH">
      </div>
      <div class="form-group mt-3">
        <label>Max Length</label>
        <input class="form-control" type="text" name="maxlength" [(ngModel)]="rowData.MAX_LENGTH">
      </div>
      <div class="form-group mt-3">
        <label>Min Occurs</label>
        <input class="form-control" type="text" name="minoccurs" [(ngModel)]="rowData.MIN_OCCURS">
      </div>
      <div class="form-group mt-3">
        <label>Max Occurs</label>
        <input class="form-control" type="text" name="maxoccurs" [(ngModel)]="rowData.MAX_OCCURS">
      </div>
      <div class="form-group mt-3">
        <label>Total Digits</label>
        <input class="form-control" type="text" name="totaldigits" [(ngModel)]="rowData.TOTAL_DIGITS">
      </div>
      <div class="form-group mt-3">
        <label>Fraction Digits</label>
        <input class="form-control" type="text" name="fraction" [(ngModel)]="rowData.FRACTION_DIGITS">
      </div>
      <div class="form-group mt-3">
        <label>Fixed Value</label>
        <input class="form-control" type="text" name="fixedvalue" [(ngModel)]="rowData.FIXED_VALUE">
      </div>
      <div class="form-group mt-3">
        <label>Pattern</label>
        <input class="form-control" type="text" name="pattern" [(ngModel)]="rowData.PATTERN">
      </div>
      <div class="form-group mt-3">
        <label>Enum Values</label>
        <input class="form-control" type="text" name="enumvalues" [(ngModel)]="rowData.ENUM_VALUES">
      </div>
      <div class="form-group mt-3">
        <label>Min Inclusive</label>
        <input class="form-control" type="text" name="mininclusive" [(ngModel)]="rowData.MIN_INCLUSIVE">
      </div>
      <div class="form-group mt-3">
        <label>Max Inclusive</label>
        <input class="form-control" type="text" name="maxinclusive" [(ngModel)]="rowData.MAX_INCLUSIVE">
      </div>
      <div class="form-group mt-3">
        <label>Schema Name</label>
        <input class="form-control" type="text" name="schemaname" [(ngModel)]="rowData.SCHEMA_NAME">
      </div>
      <div class="form-group mt-3">
        <label>Sequence ID</label>
        <input class="form-control" type="text" name="seqid" [(ngModel)]="rowData.SEQ_ID">
      </div>
      <div class="form-group mt-3">
        <label>Tree ID</label>
        <input class="form-control" type="text" name="treeid" [(ngModel)]="rowData.TREE_ID">
      </div>
      <div class="form-group mt-3">
        <label>Tree Max Occurs</label>
        <input class="form-control" type="text" name="treemaxoccurs" [(ngModel)]="rowData.TREE_MAX_OCCURS">
      </div>
      <div class="form-group mt-3">
        <label>Form</label>
        <input class="form-control" type="text" name="form" [(ngModel)]="rowData.FORM">
      </div>
      <div class="form-group mt-3">
        <label>Folder</label>
        <input class="form-control" type="text" name="folder" [(ngModel)]="rowData.FOLDER">
      </div>
      <div class="form-group mt-3">
        <label>Is Attribute</label>
        <input class="form-control" type="text" name="isattribute" [(ngModel)]="rowData.IS_ATTRIBUTE">
      </div>
      <div class="form-group mt-3">
        <label>Is Data Provider Responsible</label>
        <input class="form-control" type="text" name="isDataProvider" [(ngModel)]="rowData.IS_DATA_PROVIDER_RESPONSIBLE">
      </div>
      <div class="form-group mt-3">
        <label>Is Choice</label>
        <input class="form-control" type="text" name="ischoice" [(ngModel)]="rowData.IS_CHOICE">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
